import React, { useEffect, useState } from "react";
import { getDashboardData } from "../../../apis/auth";
import FinanceDashboardOverview from "../adminDashboard/FinanceDashboardOverview";

const EmployeeDashboard = () => {
  const [dashData, setDashData] = useState<Record<string, any>>({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const loadDashboard = async () => {
      try {
        setLoading(true);
        setError("");
        const response = await getDashboardData({ start_date: "", end_date: "" });

        if (response?.status !== true) {
          throw new Error(response?.message || "Unable to load financer dashboard");
        }

        setDashData(response?.data || {});
      } catch (dashboardError: any) {
        console.error("Unable to load financer dashboard", dashboardError);
        setError(dashboardError?.message || "Unable to load dashboard data");
      } finally {
        setLoading(false);
      }
    };

    loadDashboard();
  }, []);

  return (
    <div className="page-wrapper finance-dashboard finance-dashboard--admin finance-dashboard--financer">
      <div className="content">
        {loading ? (
          <div className="mf-dashboard-state">
            <span className="spinner-border spinner-border-sm" aria-hidden="true" />
            <strong>Loading financer dashboard...</strong>
          </div>
        ) : error ? (
          <div className="mf-dashboard-state mf-dashboard-state--error">
            <i className="ti ti-alert-circle" />
            <strong>{error}</strong>
          </div>
        ) : (
          <FinanceDashboardOverview data={dashData} />
        )}
      </div>
    </div>
  );
};

export default EmployeeDashboard;
